import { createSmartrrModal } from "@vendor-app/utils/createModalStore";
import { UploadedFileStatus } from "../../libs/types";

interface MigrationProgressModalInfo {
  status: UploadedFileStatus;
}

export const useMigrationProgressModalStore = createSmartrrModal<MigrationProgressModalInfo>();
